<template>
  <div id="intro">
    <div class="intro--wrap">
      <div class="logo-intro--wrap">
        <img src="../assets/intro-logo.png" alt="we the food the planet"/>
      </div>
      
      <div class="device--wrap">
        <img class="device-img" src="../assets/mockup-tel.svg" />
        <div class="device--content">
          <p class="clock-time">{{time}}</p>
          <div class="notification--wrap">
            <p class="notification-title">CHAT</p>
            <div class="notification-text">
              <img src="../assets/planet-notification.svg">
              <p 
                v-html="
                  
                  $i18n.locale === 'it' ?
                  copyIntroIt
                  :
                  copyIntroEN
                
                "
              >
                
              </p>
            </div>
            <div class="open-chat" @click="openChat">
              <p>
                {{
                  
                  
                  $i18n.locale === 'it' ?
                  'Apri la chat'
                  :
                  'Open chat'
                
                
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="device--back">
        <div class="img--back img--back-black" > </div>
        <div class="img--back img--back-front" > </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapState} from 'vuex';
import DishesSlider from '@/components/DishesSlider'
import {gsap, TimelineMax, Power2, Linear} from 'gsap'

export default {
  name: 'Intro',
  components:{
    DishesSlider
  },
  props: ['fnEnd'],
  data(){
    return {
      time: '',
      copyIntroIt: `1 nuovo messaggio<br>dal Pianeta<br><b>“Dobbiamo parlare..”</b>`,
      copyIntroEN: `New message<br>from the planet<br><b>“We need to talk...”</b>`
    }
  },
  methods:{
    setClock(){
      var d = new Date();
      
      var hours = d.getHours().toString().length <= 1 ? `0${d.getHours()}` : d.getHours()
      var minutes = d.getMinutes().toString().length <= 1 ? `0${d.getMinutes()}` : d.getMinutes()
      this.time = `${hours}:${minutes}`;
    },
    transitionIn(){
      let TL = new TimelineMax();

      TL
      .to('.intro--wrap',{top: '0%', duration: 1.5, ease: Power2.easeInOut})
      .to('.logo-intro--wrap',{width: '20%', delay: .75, duration: .75, ease: Power2.easeInOut, 
        onStart: () =>{
          gsap.to('.device--wrap',{opacity: 1, y: 0, duration: .5, ease: Power2.easeIn})
          gsap.to('.device--back',{opacity: 1, y: window.innerWidth > 860 ? 15 : 0, duration: .5, ease: Power2.easeIn})
        },
        onComplete: () => {
          let notification = document.querySelector('.notification--wrap');
          setTimeout(() => notification.classList.add('buzz'), 1000)
          
        }
      })
    },
    openChat(){
      let TL = new TimelineMax();
      

      TL
      .to('.img--back-front', {top: window.innerWidth > 860 ? '-100%' : 0, duration: 1.25, ease: Power2.easeInOut})
      .to('.img--back-black', {y: 0 , duration: window.innerWidth > 860 ? 0 : 1.25, ease: Power2.easeInOut})
      .to('.device--content', {top: '-100%', duration: 1.25, ease: Power2.easeInOut}, '-=1.25')
      .to('.device--wrap', {width: '120%', duration: .5, y: '-17%', ease: Power2.easeInOut})
      .to('.device--back', {width: '100vw',height: '100vh', duration: .5, y: '0', top: 0, ease: Power2.easeInOut}, '-=.5')
      .to('.device--wrap', {opacity: 0, ease: Power2.easeInOut, duration: .5}, '-=.55')
      .to('.intro--wrap', {width: '100%', duration: 1.25, ease: Power2.easeInOut,
        onComplete: () => {
          let home = document.querySelector('.home');
          home.classList.add('chatStarted')
          gsap.to('#intro', {duration: .75, delay: .5, opacity: 0, ease: Power2.easeOut,
            onComplete: () => {
              this.fnEnd();
            }
          })
          
        }
      }, '-=1.25')
    }
  },
  mounted(){
    this.transitionIn();
    this.setClock()
  },
  computed:{
    ...mapState({
      chatStep: state => state.chatStep
    })
  }
  
}
</script>

<style lang="scss">
  #intro {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    overflow: hidden;
    z-index: 2;
    .intro--wrap{
      position: absolute;
      transform: translate(-50%, 0);
      left: 50%;
      top: 100%;
      width: 100%;
    }
    .logo-intro--wrap{
      position: relative;
      margin: 70px auto;
      width: 80%;
      will-change: width;
      img{
        display: block;
        width: 100%;
        max-width: 1100px;
      }
      @media screen and (max-width: 767px){
        min-width: 200px;
      }
    }
    .device--back{
      position: absolute;
      z-index: 1;
      width: 400px;
      opacity: 0; 
      transform: translateY(200px) translateX(-50%);
      overflow: hidden;
      height: 785px;
      left: 50%;
      .img--back{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-image: url('../assets/device-back.svg');
        background-position: 50%;
        background-size: cover;
        &.img--back-black{
          background-image: url('../assets/chat-bg/bg-yellow.jpg');
          
        }
      }
      @media screen and (max-width: 767px){
        height: 100vh;
        top: 0;
        width: 100%;
        .img--back-front{
          display: none;
        }
        .img--back.img--back-black{
          transform: translate(0%, 100%);
        }
      }
    }
    .device--wrap{
      position: absolute;
      margin: 0 auto;
      width: 450px;
      opacity: 0;
      transform: translateY(200px) translateX(-50%);
      text-align: center;
      overflow: hidden;
      left: 50%;
      z-index: 3;
      img{
        display: block;
        &.device-img{
          position: relative;
          z-index: 3;
          width: 100%;
          top: 0;
          left: 0;
          pointer-events: none;
          @media screen and (max-width: 767px){
            opacity: 0;
          }
        }
      }
      .device--content{
        position: absolute;
        top: 80px;
        z-index: 2;
        left: 50%;
        width: 95%;
        transform: translate(-50%,0);
      }
      .clock-time{
        text-align: center;
        color: #fff;
        font-size: 80px;
        white-space: nowrap;
        @media screen and (max-width: 767px){
          display: none;
        }
      }
      .notification--wrap{
        position: relative;
        margin: 0 auto;
        width: 70%;
        border-radius: 20px;
        border: 2px solid #000;
        background-color: #E2E7EC;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .notification-title{
          font-size: 24px;
          line-height: 52px;
          border-bottom: 2px solid #000;
          text-align: left;
          padding-left: 20px;
        }
        .notification-text{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          border-bottom: 2px solid #000;
          text-align: left;
          padding: 20px 0;
          margin: 0 auto;
          width: 100%;
          img{
            margin: 0 20px;
          }
        }
        .open-chat{
          position: relative;
          background-color: #7E32B4;
          color: #fff;
          cursor: pointer;
          transition: background-color .5s ease-out, color .5s ease-out;
          &:hover{
            background-color: #fff;
            color: #7E32B4;
          }
          p{
            font-size: 24px;
            line-height: 52px;
            text-align: center;
          }
        }
        &.buzz{
          animation: buzz 3s infinite;
        }
      }
    }
  }

  @keyframes buzz {
    3%, 15% {
      transform: translate3d(-1px, 0, 0) rotate(-5deg);
    }
    
    6%, 18% {
      transform: translate3d(2px, 0, 0) rotate(2deg);
    }

    9%, 21% {
      transform: translate3d(-2px, 0, 0) rotate(-2deg);
    }

    12%, 24% {
      transform: translate3d(3px, 0, 0) rotate(3deg);
    }
    27%, 100% {
      transform: translate3d(0, 0, 0) rotate(0deg);
    }
  }
</style>